import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { MaterialModule } from '@app/material.module'
import { WidgetsModule } from '@widgets/widgets.module'
import { FooterComponent } from './footer/footer.component'
import { GovbarOnlyLayoutComponent } from './govbar-only-layout/govbar-only-layout.component'
import { GovbarComponent } from './govbar/govbar.component'
import { HeaderComponent } from './header/header.component'
import { MainLayoutComponent } from './main-layout/main-layout.component'
import { InfoUserComponent } from './sidenav/info-user/info-user.component'
import { SidenavComponent } from './sidenav/sidenav.component'

@NgModule({
  imports: [CommonModule, MaterialModule, RouterModule, WidgetsModule],
  declarations: [
    HeaderComponent,
    MainLayoutComponent,
    SidenavComponent,
    GovbarComponent,
    GovbarOnlyLayoutComponent,
    FooterComponent,
    InfoUserComponent,
  ],
  exports: [
    HeaderComponent,
    MainLayoutComponent,
    SidenavComponent,
    GovbarComponent,
    GovbarOnlyLayoutComponent,
    FooterComponent,
  ],
})
export class LayoutModule {}
